import Vue, { onMounted } from 'vue'
import httpManager from '../../util/common'
import { message } from 'ant-design-vue'
import { watch } from 'less'

Vue.config.productionTip = false

let email_push_item = {
  name: 'EmailPushItem',
  props:['product', 'type_list', 'title', 'checkedList'],
  data: () => {
    return {
      CheckedList: [],
      Indeterminate: true,
      CheckAll: false,
      BtnDisabled: true,
      isFirstGet: true
    }
  },
  watch: {
    checkedList: function(newVal, oldVal) {
      if (!this.isFirstGet) return
      this.isFirstGet = false
      this.CheckedList = newVal
      if (this.CheckedList.length === this.type_list.length) {
        this.CheckAll = true
        this.Indeterminate = false
      }
    }
  },
  methods: {
    saveConfig(product, config) {
      this.BtnDisabled = true
      let params = new Map()
      params.set('product', product)
      params.set('config', config)
      httpManager("update_email_push", params, null, null, null)
        .then(response => {
          message.success('保存成功')

        })
        .catch(error => {
          message.error('保存失败')
          this.BtnDisabled = false
        })
    },
    OnChange(CheckedList) {
      this.BtnDisabled = false
      this.Indeterminate = !!CheckedList.length && CheckedList.length < this.type_list.length;
      this.CheckAll = CheckedList.length === this.type_list.length;
    },
    OnCheckAllChange(e) {
      Object.assign(this, {
        CheckedList: e.target.checked ? this.type_list_value : [],
        Indeterminate: false,
        CheckAll: e.target.checked,
        BtnDisabled : false
      });
    }
  },
  computed: {
    type_list_value() {
      return this.type_list.map(item => item.value)
    }
  }
}
export default email_push_item


// WEBPACK FOOTER //
// ./src/user_center/js/email_push_item.js